import { defineComponent, ref, computed, openBlock, createElementBlock, normalizeClass, createElementVNode, renderSlot } from 'vue';

var LabelVariant;
(function (LabelVariant) {
  LabelVariant["Input"] = "input";
  LabelVariant["Toggle"] = "toggle";
  LabelVariant["Group"] = "group";
  LabelVariant["MenuItem"] = "menu-item";
})(LabelVariant || (LabelVariant = {}));

const Label = [
// Layout
'layout-row justify-between',
// Spacing
'gap-sm'];
const LabelVariants = {
  [LabelVariant.Input]: [
  // Typography
  'typography-caption-regular',
  // Theme
  'theme-foreground-outline', 'dark:theme-foreground-outline-dark'],
  [LabelVariant.Toggle]: [
  // Typography
  'typography-body-2-regular',
  // Theme
  'theme-foreground-default', 'dark:theme-foreground-default-dark'],
  [LabelVariant.Group]: [
  // Typography
  'typography-body-2-regular',
  // Theme
  'theme-foreground-default', 'dark:theme-foreground-default-dark',
  // Theme (invalid)
  'invalid:theme-foreground-error', 'dark:invalid:theme-foreground-error-dark'],
  [LabelVariant.MenuItem]: [
  // Typography
  'typography-body-2-regular',
  // Typography (selected)
  'selected:typography-body-2-semibold',
  // Theme
  'theme-foreground-default', 'dark:theme-foreground-default-dark']
};
const LabelContent = [
// Interactivity
'interactivity-default',
// Interactivity (read-only)
'read-only:interactivity-none',
// Content (required)
'required:after:content-["*"]'];
const LabelAddon = [
// Layout
'layout-inline-row empty:hidden',
// Typography
'whitespace-nowrap'];

var script = defineComponent({
  name: 'OrLabel',
  props: {
    controlId: {
      type: String,
      default: undefined
    },
    variant: {
      type: String,
      default: () => LabelVariant.Input
    },
    invalid: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  expose: ['root'],
  setup(props) {
    // Refs & Styles
    const root = ref();
    const rootStyles = computed(() => ['or-label-v3', ...Label, ...LabelVariants[props.variant]]);
    const contentStyles = computed(() => [...LabelContent]);
    const addonStyles = computed(() => [...LabelAddon]);
    return {
      root,
      rootStyles,
      contentStyles,
      addonStyles
    };
  }
});

const _hoisted_1 = ["invalid", "selected", "disabled"];
const _hoisted_2 = ["for", "required", "disabled", "readonly"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles),
    invalid: _ctx.invalid,
    selected: _ctx.selected,
    disabled: _ctx.disabled
  }, [createElementVNode("label", {
    class: normalizeClass(_ctx.contentStyles),
    for: _ctx.controlId,
    required: _ctx.required,
    disabled: _ctx.disabled,
    readonly: _ctx.readonly
  }, [renderSlot(_ctx.$slots, "default")], 10 /* CLASS, PROPS */, _hoisted_2), createElementVNode("div", {
    class: normalizeClass(_ctx.addonStyles)
  }, [renderSlot(_ctx.$slots, "addon")], 2 /* CLASS */)], 10 /* CLASS, PROPS */, _hoisted_1);
}

script.render = render;
script.__file = "src/components/or-label-v3/OrLabel.vue";

export { LabelVariant, script as OrLabelV3 };
